import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Questionnaire from '../questionnaire/Questionnaire';
import { auth, firestore } from '../../../services/firebase';
import { doc, DocumentReference, getDoc, onSnapshot, setDoc } from 'firebase/firestore';
import { ModeRouteParams } from '../mode/Mode';
import { CharacterSeed } from '../avatar/Avatar';
import GameContext from '../../context/GameContext';

interface GroupProps {}

const Group: FunctionComponent<GroupProps> = () => {
    const { groupId } = useParams<ModeRouteParams>();
    const [groupState, setGroupState] = useState<GroupGame | null>(null);

    const { avatarSeed, playerName } = useContext(GameContext);

    const checkGroupStatus = async (gameRef: DocumentReference) => {
        const gameSnap = await getDoc(gameRef);

        if (gameSnap.exists()) {
            const existingGroup = gameSnap.data() as GroupGame;

            const isUserJoined = existingGroup.players.findIndex((player) => player.uid === auth.currentUser?.uid);

            if (isUserJoined >= 0) {
            } else {
                if (!auth.currentUser) {
                    return;
                }

                if (existingGroup.players.length >= 4) {
                    return;
                }

                const updatedGroup: GroupGame = {
                    ...existingGroup,
                    players: [
                        ...existingGroup.players,
                        {
                            uid: auth.currentUser?.uid,
                            name: auth.currentUser.displayName?.replace(' ', '') || playerName,
                            score: 0,
                            seed: avatarSeed,
                            isPlaying: true,
                        },
                    ],
                };

                await setDoc(gameRef, updatedGroup, { merge: true });
                console.log('Group updated:', updatedGroup);
            }
        } else {
            if (!auth.currentUser) {
                console.log('Must be logged in!');
                return;
            }

            const newGroup: GroupGame = {
                ...DEFAULT_GAME,
                players: [
                    {
                        uid: auth.currentUser?.uid,
                        name: auth.currentUser.displayName?.replace(' ', '') || playerName,
                        score: 0,
                        seed: avatarSeed,
                        isPlaying: true,
                    },
                ],
            };

            await setDoc(gameRef, newGroup, { merge: true });
        }
    };

    useEffect(() => {
        const gameRef = doc(firestore, 'games', groupId);

        checkGroupStatus(gameRef);

        const unsub = onSnapshot(gameRef, (doc) => {
            const updatedGame = doc.data() as GroupGame;
            setGroupState(updatedGame);
        });

        return () => {
            unsub();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <Questionnaire groupGame={groupState} />;
};

export const updatePlayerScoreInGroup = async (groupId: string, score: number, uid: string) => {
    const gameRef = doc(firestore, 'games', groupId);
    const gameSnap = await getDoc(gameRef);

    if (gameSnap.exists()) {
        const { players } = gameSnap.data() as GroupGame;

        const playerIndex = players.findIndex((player) => player.uid === uid);

        if (playerIndex >= 0) {
            const playersData = [...players];

            if (playersData[playerIndex].isPlaying) {
                playersData[playerIndex].score += 1;
                await setDoc(gameRef, { players: playersData });
            }
        }
    }
};

interface Player {
    uid: string;
    name: string;
    seed: CharacterSeed;
    score: number;
    isPlaying: boolean;
}

export interface GroupGame {
    isActive: boolean;
    players: Array<Player>;
}

const DEFAULT_GAME: GroupGame = {
    isActive: true,
    players: [],
};

export default Group;
